import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateNewsletterForm from "../../forms/CreateOrUpdateNewsletterForm";
import { NewsletterResponseDto } from "../../shared/dtos/newsletter/NewsletterResponseDto";

interface UpdateNewsletterModalProps {
  open: boolean;
  onClose: () => void;
  newsletter: NewsletterResponseDto | null;
  loading: boolean;
  error: string | null;
}

const UpdateNewsletterModal: React.FC<UpdateNewsletterModalProps> = ({
  open,
  onClose,
  newsletter,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit: ${newsletter?.title || ""}`}
    width="md"
    loading={loading}
  >
    <CreateOrUpdateNewsletterForm
      isEditing={true}
      newsletter={newsletter}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateNewsletterModal;
